import { render, staticRenderFns } from "./SalesMarginsReport.vue?vue&type=template&id=db9fe8f2&"
import script from "./SalesMarginsReport.vue?vue&type=script&lang=js&"
export * from "./SalesMarginsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports